<template>
  <app-page-title :color="'sun'">
    <template #pageTitleLeft>
      <h1>Confirmation</h1>
    </template>
    <template #pageTitleRight>
      <router-link :to="{name: 'billing-manage-payment-methods'}">Manage Payment Methods</router-link>
      <a href='javascript:void(0)' @click='print' class='_mls btn --sm'>Print</a>
      <router-link class="_mls btn --sm" :to="{name: 'billing-overview'}">Billing Home</router-link>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'

  export default {
    components: {
      AppPageTitle
    },
    methods: {
      print () {
        window.print()
      }
    }
  }
</script>
